// Environment-safe dev-guard predicate for the library's accessibility
// assertions ("aria-label is required", "totalPages must be ≥ 1", ...).
//
// The previous inline pattern — `process.env["NODE_ENV"] !== "production"`
// — crashed in the BROWSER: Vite statically replaces the dot-notation
// `process.env.NODE_ENV` only; the bracket form survives the transform
// and throws `ReferenceError: process is not defined` at runtime. The
// library ran exclusively under vitest (node) until the novem skin made
// it browser-mounted, which surfaced the latent bug.
//
// This helper answers "are we in a development build?" in BOTH worlds:
//   * Vite browser dev / vitest: `import.meta.env.DEV === true`
//   * Node (SSR, plain vitest without vite env): NODE_ENV !== production
// Production builds answer false on both branches, so the guards (and
// their throw statements) stay out of user-facing paths.

interface MaybeViteImportMeta {
  readonly env?: { readonly DEV?: boolean };
}

export function isDevGuardActive(): boolean {
  const meta = import.meta as MaybeViteImportMeta;
  if (meta.env?.DEV === true) return true;
  return typeof process !== "undefined" && process.env["NODE_ENV"] !== "production";
}
